export default {
  'pages.layouts.userLayout.title': 'こんにちは！',
  'pages.getCaptchaSecondText': '秒',
  'pages.workbench.link': 'ようこそ',
  'pages.workbench.alertMessage':
    'より高速で強力な頑丈なコンポーネントがリリースされました。',
  'pages.404.subTitle':
    '申し訳ありませんが、アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.admin.subPage.title': 'このページは管理者のみが表示できます',
  'pages.admin.subPage.alertMessage':
    'Umi uiがリリースされました。npm run uiを使用して体験してください。',
  'pages.searchTable.createForm.newRule': '新しいルール',
  'pages.searchTable.updateForm.ruleConfig': 'ルール構成',
  'pages.searchTable.updateForm.basicConfig': '基本情報',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'ルール名を入力してください！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルールの説明',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '5文字以上入力してください',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '5文字以上のルールの説明を入力してください！',
  'pages.searchTable.updateForm.ruleProps.title': 'プロパティの構成',
  'pages.searchTable.updateForm.object': '監視対象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'スケジュール期間の設定',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '開始時間を選択してください！',
  'pages.searchTable.titleDesc': '説明',
  'pages.searchTable.ruleName': 'ルール名が必要です',
  'pages.searchTable.titleCallNo': 'サービスコール数',
  'pages.searchTable.titleStatus': 'ステータス',
  'pages.searchTable.nameStatus.default': 'デフォルト',
  'pages.searchTable.nameStatus.running': '起動中',
  'pages.searchTable.nameStatus.online': 'オンライン',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  'pages.searchTable.exception': '例外の理由を入力してください！',
  'pages.searchTable.titleOption': 'オプション',
  'pages.searchTable.config': '構成',
  'pages.searchTable.subscribeAlert': 'アラートを購読する',
  'pages.searchTable.title': 'お問い合わせフォーム',
  'pages.searchTable.new': '新しい',
  'pages.searchTable.chosen': '選んだ項目',
  'pages.searchTable.item': '項目',
  'pages.searchTable.totalServiceCalls': 'サービスコールの総数',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': 'バッチ削除',
  'pages.searchTable.batchApproval': 'バッチ承認',
  'pages.zy-crm.lead.title': 'リード一覧',
  'pages.zy-crm.customer.title': '顧客一覧',
  'pages.zy-crm.contact.title': '連絡先一覧',
  'pages.zy-crm.contact.detailTitle': '連絡先詳細',
  'pages.zy-crm.common.confirmDelete': '削除を確認',
  'pages.zy-crm.common.confirmDeleteContent':
    '削除後は復元できません。ご注意ください。',
  'pages.zy-crm.common.deleteSuccess': '削除しました',
  'pages.zy-crm.common.updateSuccess': '更新しました',
  'pages.zy-crm.common.createSuccess': '作成しました',
  'pages.zy-crm.common.operation': '操作',
  'pages.zy-crm.common.detail': '詳細',
  'pages.zy-crm.common.edit': '編集',
  'pages.zy-crm.common.delete': '削除',
  'pages.zy-crm.common.refresh': '更新',
  'pages.zy-crm.common.create': '新規作成',
  'pages.zy-crm.common.detailLoadFailed': '詳細の読み込みに失敗しました',
  'pages.zy-crm.common.missingUuid': 'uuid パラメータがありません',
  'pages.zy-crm.common.noDetailData': '詳細データが見つかりません',
  'pages.zy-crm.common.id': 'ID',
  'pages.zy-crm.common.relatedData': '関連データ',
  'pages.zy-crm.common.relatedDataTodo':
    '関連データは業務APIに合わせて拡張できます',
  'pages.zy-crm.common.required': '必須項目です',
  'pages.zy-crm.common.yes': 'はい',
  'pages.zy-crm.common.no': 'いいえ',
  'pages.zy-crm.opportunityPipelines.title': '商談パイプライン設定',
  'pages.zy-crm.opportunityStages.title': '商談ステージ設定',
  'pages.zy-crm.areas.title': '地域設定',
  'pages.zy-crm.industries.title': '業界設定',
  'pages.zy-crm.productCategories.title': '商品カテゴリ設定',
  'pages.zy-crm.sourceChannels.title': '流入チャネル設定',
  'pages.zy-crm.dictionary.column.id': 'ID',
  'pages.zy-crm.dictionary.column.uuid': '識別子',
  'pages.zy-crm.dictionary.column.name': '名称',
  'pages.zy-crm.dictionary.column.updateTime': '更新日時',
  'pages.zy-crm.dictionary.confirmDeleteOne': 'このレコードを削除しますか？',
  'pages.zy-crm.dictionary.modal.editTitle': '{title}を編集',
  'pages.zy-crm.dictionary.modal.createTitle': '{title}を新規作成',
  'pages.zy-crm.dictionary.validation.nameRequired': '名称は必須です',
  'pages.zy-crm.dictionary.validation.enterName': '名称を入力してください',
  'pages.zy-crm.dictionary.field.name': '名称',
  'pages.zy-crm.dictionary.field.uuidOptional': '識別子（システム生成）',
  'pages.zy-crm.dictionary.field.uuidHint':
    'システムで自動生成されるため手入力は不要です',
  'pages.zy-crm.dictionaryManagement.field.type': '辞書タイプ',
  'pages.zy-crm.contact.management': '連絡先管理',
  'pages.zy-crm.contact.unknownMember': '不明なメンバー',
  'pages.zy-crm.contact.memberLoadFailed':
    'メンバー一覧の読み込みに失敗しました。後でもう一度お試しください。',
  'pages.zy-crm.contact.memberLoadFailedSubmit':
    'メンバー一覧の読み込みに失敗したため、送信できません。',
  'pages.zy-crm.contact.field.name': '連絡先名',
  'pages.zy-crm.contact.field.customer': '顧客',
  'pages.zy-crm.contact.field.lastContactTime': '最終連絡日時',
  'pages.zy-crm.contact.field.lastContactContent': '最終連絡内容',
  'pages.zy-crm.contact.field.nextContactTime': '次回連絡日時',
  'pages.zy-crm.contact.field.owner': '担当者',
  'pages.zy-crm.contact.field.mobile': '携帯電話',
  'pages.zy-crm.contact.field.telephone': '電話',
  'pages.zy-crm.contact.field.email': 'メール',
  'pages.zy-crm.contact.field.qq': 'QQ',
  'pages.zy-crm.contact.field.wechat': 'WeChat',
  'pages.zy-crm.contact.field.area': '地域',
  'pages.zy-crm.contact.field.parent': '上位連絡先',
  'pages.zy-crm.contact.field.detailAddress': '詳細住所',
  'pages.zy-crm.contact.field.remark': '備考',
  'pages.zy-crm.contact.field.post': '役職',
  'pages.zy-crm.contact.field.sex': '性別',
  'pages.zy-crm.contact.field.isPrimaryDecisionMaker': '主要意思決定者',
  'pages.zy-crm.contact.placeholder.name': '連絡先名を入力してください',
  'pages.zy-crm.contact.placeholder.lastContactContent':
    '最終連絡内容を入力してください',
  'pages.zy-crm.contact.placeholder.lastContactTime':
    '最終連絡日時を選択してください',
  'pages.zy-crm.contact.placeholder.nextContactTime':
    '次回連絡日時を選択してください',
  'pages.zy-crm.contact.placeholder.email': 'メールを入力してください',
  'pages.zy-crm.contact.placeholder.mobile': '携帯電話を入力してください',
  'pages.zy-crm.contact.placeholder.qq': 'QQを入力してください',
  'pages.zy-crm.contact.placeholder.telephone': '電話番号を入力してください',
  'pages.zy-crm.contact.placeholder.wechat': 'WeChatを入力してください',
  'pages.zy-crm.contact.placeholder.area': '地域IDを入力してください',
  'pages.zy-crm.contact.placeholder.customer': '顧客IDを入力してください',
  'pages.zy-crm.contact.placeholder.owner': '担当者を選択してください',
  'pages.zy-crm.contact.placeholder.parent': '上位連絡先IDを入力してください',
  'pages.zy-crm.contact.placeholder.detailAddress':
    '詳細住所を入力してください',
  'pages.zy-crm.contact.placeholder.remark': '備考を入力してください',
  'pages.zy-crm.contact.placeholder.isPrimaryDecisionMaker':
    '主要意思決定者かどうかを選択してください',
  'pages.zy-crm.contact.placeholder.post': '役職を入力してください',
  'pages.zy-crm.contact.placeholder.sex': '性別コードを入力してください',
  'pages.zy-crm.contact.section.basic': '基本情報',
  'pages.zy-crm.contact.section.followUp': 'フォロー情報',
  'pages.zy-crm.contact.section.contact': '連絡先情報',
  'pages.zy-crm.contact.section.relation': '関連情報',
  'pages.zy-crm.contact.section.remark': '備考',
  'pages.zy-crm.contact.section.other': 'その他情報',
  'pages.zy-crm.opportunity.title': 'Opportunity 一覧',
  'pages.zy-crm.opportunity.detailTitle': 'Opportunity 詳細',
  'pages.zy-crm.opportunity.card.manageTitle': 'Opportunity 管理',
  'pages.zy-crm.opportunity.action.refresh': '更新',
  'pages.zy-crm.opportunity.action.create': '新規作成',
  'pages.zy-crm.opportunity.action.detail': '詳細',
  'pages.zy-crm.opportunity.action.edit': '編集',
  'pages.zy-crm.opportunity.action.delete': '削除',
  'pages.zy-crm.opportunity.column.operation': '操作',
  'pages.zy-crm.opportunity.modal.createTitle': '新規作成',
  'pages.zy-crm.opportunity.modal.editTitle': '編集',
  'pages.zy-crm.opportunity.modal.deleteTitle': '削除確認',
  'pages.zy-crm.opportunity.modal.deleteContent': '削除後は復元できません。',
  'pages.zy-crm.opportunity.form.required': '必須項目です',
  'pages.zy-crm.opportunity.form.placeholder.input':
    '{label}を入力してください',
  'pages.zy-crm.opportunity.form.placeholder.select':
    '{label}を選択してください',
  'pages.zy-crm.opportunity.form.placeholder.relation':
    '関連{label}を入力してください',
  'pages.zy-crm.opportunity.form.bool.yes': 'はい',
  'pages.zy-crm.opportunity.form.bool.no': 'いいえ',
  'pages.zy-crm.opportunity.form.group.basic': '基本情報',
  'pages.zy-crm.opportunity.form.group.followup': 'フォローアップ情報',
  'pages.zy-crm.opportunity.form.group.contact': '連絡先情報',
  'pages.zy-crm.opportunity.form.group.business': '業務情報',
  'pages.zy-crm.opportunity.form.group.relation': '関連情報',
  'pages.zy-crm.opportunity.form.group.detail': '備考',
  'pages.zy-crm.opportunity.form.group.other': 'その他情報',
  'pages.zy-crm.opportunity.message.createSuccess': '作成に成功しました',
  'pages.zy-crm.opportunity.message.updateSuccess': '更新に成功しました',
  'pages.zy-crm.opportunity.message.deleteSuccess': '削除に成功しました',
  'pages.zy-crm.opportunity.message.noCreateApi':
    '作成 API が提供されていません',
  'pages.zy-crm.opportunity.message.noUpdateApi':
    '更新 API が提供されていません',
  'pages.zy-crm.opportunity.message.noDeleteApi':
    '削除 API が提供されていません',
  'pages.zy-crm.opportunity.message.memberLoadFailed':
    'メンバー一覧の取得に失敗しました',
  'pages.zy-crm.opportunity.message.memberLoadBlocked':
    'メンバー取得失敗のため送信できません',
  'pages.zy-crm.opportunity.message.detailLoadFailed':
    '詳細の読み込みに失敗しました',
  'pages.zy-crm.opportunity.member.unknown': '不明なメンバー',
  'pages.zy-crm.opportunity.state.missingUuid': 'uuid パラメータがありません',
  'pages.zy-crm.opportunity.state.detailNotFound': '詳細データが見つかりません',
  'pages.zy-crm.opportunity.state.relationDataEmpty':
    '関連データは業務 API で補完できます',
  'pages.zy-crm.opportunity.card.relation': '関連データ',
  'pages.zy-crm.opportunity.field.id': 'ID',
  'pages.zy-crm.opportunity.field.name': '商談名',
  'pages.zy-crm.opportunity.field.customer': '顧客',
  'pages.zy-crm.opportunity.field.followUpStatus': 'フォローアップ状態',
  'pages.zy-crm.opportunity.field.contactLastTime': '最終連絡日時',
  'pages.zy-crm.opportunity.field.contactNextTime': '次回連絡日時',
  'pages.zy-crm.opportunity.field.ownerUser': '担当者',
  'pages.zy-crm.opportunity.field.pipeline': 'パイプライン',
  'pages.zy-crm.opportunity.field.stage': 'ステージ',
  'pages.zy-crm.opportunity.field.endStatus': '終了状態',
  'pages.zy-crm.opportunity.field.dealTime': '成約日時',
  'pages.zy-crm.opportunity.field.totalProductPrice': '製品合計金額',
  'pages.zy-crm.opportunity.field.discountPercent': '割引率',
  'pages.zy-crm.opportunity.field.totalPrice': '合計金額',
  'pages.zy-crm.opportunity.field.remark': '備考',
  'pages.zy-crm.opportunity.field.endRemark': '終了備考',
  'pages.zy-crm.product.title': '商品一覧',
  'pages.zy-crm.product.detailTitle': '商品詳細',
  'pages.zy-crm.product.card.manageTitle': '商品管理',
  'pages.zy-crm.product.field.name': '商品名',
  'pages.zy-crm.product.field.code': '商品コード',
  'pages.zy-crm.product.field.unit': '製品単位',
  'pages.zy-crm.product.field.price': '価格',
  'pages.zy-crm.product.field.costPrice': '原価',
  'pages.zy-crm.product.field.status': '販売状態',
  'pages.zy-crm.product.field.category': '製品タイプ',
  'pages.zy-crm.product.field.description': '製品説明',
  'pages.zy-crm.product.field.mainImage': '商品メイン画像',
  'pages.zy-crm.product.field.detailImages': '商品詳細画像',
  'pages.zy-crm.product.field.owner': '担当者',
  'pages.zy-crm.product.action.refresh': '更新',
  'pages.zy-crm.product.action.create': '新規作成',
  'pages.zy-crm.product.action.detail': '詳細',
  'pages.zy-crm.product.action.edit': '編集',
  'pages.zy-crm.product.action.delete': '削除',
  'pages.zy-crm.product.column.operation': '操作',
  'pages.zy-crm.product.modal.createTitle': '製品を新規作成',
  'pages.zy-crm.product.modal.editTitle': '製品を編集',
  'pages.zy-crm.product.modal.deleteTitle': '削除確認',
  'pages.zy-crm.product.modal.deleteContent': '削除後は復元できません。',
  'pages.zy-crm.product.form.required': '必須項目です',
  'pages.zy-crm.product.form.placeholder.input': '{label}を入力してください',
  'pages.zy-crm.product.form.placeholder.select': '{label}を選択してください',
  'pages.zy-crm.product.form.placeholder.relation':
    '関連{label}を入力してください',
  'pages.zy-crm.product.form.bool.yes': 'はい',
  'pages.zy-crm.product.form.bool.no': 'いいえ',
  'pages.zy-crm.product.form.group.basic': '基本情報',
  'pages.zy-crm.product.form.group.followup': 'フォローアップ情報',
  'pages.zy-crm.product.form.group.contact': '連絡先情報',
  'pages.zy-crm.product.form.group.business': '業務情報',
  'pages.zy-crm.product.form.group.relation': '関連情報',
  'pages.zy-crm.product.form.group.detail': '備考',
  'pages.zy-crm.product.form.group.other': 'その他情報',
  'pages.zy-crm.product.form.autoCodeHint': '採番ルールにより自動生成',
  'pages.zy-crm.product.enum.status.enabled': '有効/販売中',
  'pages.zy-crm.product.enum.status.disabled': '無効/販売停止',
  'pages.zy-crm.product.message.createSuccess': '作成に成功しました',
  'pages.zy-crm.product.message.updateSuccess': '更新に成功しました',
  'pages.zy-crm.product.message.deleteSuccess': '削除に成功しました',
  'pages.zy-crm.product.message.noCreateApi': '作成 API が提供されていません',
  'pages.zy-crm.product.message.noUpdateApi': '更新 API が提供されていません',
  'pages.zy-crm.product.message.noDeleteApi': '削除 API が提供されていません',
  'pages.zy-crm.product.message.memberLoadFailed':
    'メンバー一覧の取得に失敗しました',
  'pages.zy-crm.product.message.memberLoadBlocked':
    'メンバー取得失敗のため送信できません',
  'pages.zy-crm.product.message.detailLoadFailed':
    '詳細の読み込みに失敗しました',
  'pages.zy-crm.product.member.unknown': '不明なメンバー',
  'pages.zy-crm.product.state.missingUuid': 'uuid パラメータがありません',
  'pages.zy-crm.product.state.detailNotFound': '詳細データが見つかりません',
  'pages.zy-crm.product.state.relationDataEmpty':
    '関連データは業務 API で補完できます',
  'pages.zy-crm.product.card.relation': '関連データ',
  'pages.zy-crm.contract.title': 'Contract 一覧',
  'pages.zy-crm.contract.detailTitle': 'Contract 詳細',
  'pages.zy-crm.contract.card.manageTitle': 'Contract 管理',
  'pages.zy-crm.contract.action.refresh': '更新',
  'pages.zy-crm.contract.action.create': '新規作成',
  'pages.zy-crm.contract.action.detail': '詳細',
  'pages.zy-crm.contract.action.edit': '編集',
  'pages.zy-crm.contract.action.delete': '削除',
  'pages.zy-crm.contract.column.operation': '操作',
  'pages.zy-crm.contract.modal.createTitle': '新規作成',
  'pages.zy-crm.contract.modal.editTitle': '編集',
  'pages.zy-crm.contract.modal.deleteTitle': '削除確認',
  'pages.zy-crm.contract.modal.deleteContent': '削除後は復元できません。',
  'pages.zy-crm.contract.form.required': '必須項目です',
  'pages.zy-crm.contract.form.placeholder.input': '{label}を入力してください',
  'pages.zy-crm.contract.form.placeholder.select': '{label}を選択してください',
  'pages.zy-crm.contract.form.placeholder.relation':
    '関連{label}を入力してください',
  'pages.zy-crm.contract.form.bool.yes': 'はい',
  'pages.zy-crm.contract.form.bool.no': 'いいえ',
  'pages.zy-crm.contract.form.group.basic': '基本情報',
  'pages.zy-crm.contract.form.group.followup': 'フォローアップ情報',
  'pages.zy-crm.contract.form.group.contact': '連絡先情報',
  'pages.zy-crm.contract.form.group.business': '業務情報',
  'pages.zy-crm.contract.form.group.relation': '関連情報',
  'pages.zy-crm.contract.form.group.sign': '署名情報',
  'pages.zy-crm.contract.form.group.product': '商品情報',
  'pages.zy-crm.contract.form.group.amount': '金額集計',
  'pages.zy-crm.contract.form.group.detail': '備考',
  'pages.zy-crm.contract.form.group.other': 'その他情報',
  'pages.zy-crm.contract.form.autoCodeHint': '採番ルールにより自動生成',
  'pages.zy-crm.contract.message.createSuccess': '作成に成功しました',
  'pages.zy-crm.contract.message.updateSuccess': '更新に成功しました',
  'pages.zy-crm.contract.message.deleteSuccess': '削除に成功しました',
  'pages.zy-crm.contract.message.noCreateApi': '作成 API が提供されていません',
  'pages.zy-crm.contract.message.noUpdateApi': '更新 API が提供されていません',
  'pages.zy-crm.contract.message.noDeleteApi': '削除 API が提供されていません',
  'pages.zy-crm.contract.message.memberLoadFailed':
    'メンバー一覧の取得に失敗しました',
  'pages.zy-crm.contract.message.customerLoadFailed':
    '顧客一覧の取得に失敗しました',
  'pages.zy-crm.contract.message.opportunityLoadFailed':
    '商談一覧の取得に失敗しました',
  'pages.zy-crm.contract.message.memberLoadBlocked':
    'メンバー取得失敗のため送信できません',
  'pages.zy-crm.contract.message.detailLoadFailed':
    '詳細の読み込みに失敗しました',
  'pages.zy-crm.contract.message.loadDetailFailed':
    '契約詳細の読み込みに失敗しました',
  'pages.zy-crm.contract.message.productEmpty':
    '商品明細を少なくとも1件追加してください',
  'pages.zy-crm.contract.member.unknown': '不明なメンバー',
  'pages.zy-crm.contract.state.missingUuid': 'uuid パラメータがありません',
  'pages.zy-crm.contract.state.detailNotFound': '詳細データが見つかりません',
  'pages.zy-crm.contract.state.relationDataEmpty':
    '関連データは業務 API で補完できます',
  'pages.zy-crm.contract.card.relation': '関連データ',
  'pages.zy-crm.contract.card.productDetail': '商品明細',
  'pages.zy-crm.contract.search.expand': '展開',
  'pages.zy-crm.contract.search.collapse': '折りたたみ',
  'pages.zy-crm.contract.enum.type.standard': '標準契約',
  'pages.zy-crm.contract.enum.type.framework': '基本契約',
  'pages.zy-crm.contract.enum.type.supplement': '追加契約',
  'pages.zy-crm.contract.action.addProduct': '商品を追加',
  'pages.zy-crm.contract.action.addRow': '行を追加',
  'pages.zy-crm.contract.table.emptyProducts': '商品明細はありません',
  'pages.zy-crm.contract.field.id': 'ID',
  'pages.zy-crm.contract.field.name': '名称',
  'pages.zy-crm.contract.field.code': '契約番号',
  'pages.zy-crm.contract.field.customer': '顧客',
  'pages.zy-crm.contract.field.opportunity': '商談',
  'pages.zy-crm.contract.field.contactLastTime': '最終連絡日時',
  'pages.zy-crm.contract.field.ownerUser': '担当者',
  'pages.zy-crm.contract.field.processInstance': 'プロセスインスタンス',
  'pages.zy-crm.contract.field.auditStatus': '承認状態',
  'pages.zy-crm.contract.field.orderDate': '受注日',
  'pages.zy-crm.contract.field.startTime': '開始日時',
  'pages.zy-crm.contract.field.endTime': '終了日時',
  'pages.zy-crm.contract.field.contractType': '契約タイプ',
  'pages.zy-crm.contract.field.customerSigner': '顧客署名者',
  'pages.zy-crm.contract.field.companySignerUserUuid': '自社署名者',
  'pages.zy-crm.contract.field.signContactUuid': '署名連絡先',
  'pages.zy-crm.contract.field.signUserUuid': '署名担当者',
  'pages.zy-crm.contract.field.contractImageUrl': '契約イメージURL',
  'pages.zy-crm.contract.field.totalProductPrice': '商品合計金額',
  'pages.zy-crm.contract.field.discountPercent': '割引率',
  'pages.zy-crm.contract.field.totalPrice': '契約合計金額',
  'pages.zy-crm.contract.field.profitAmount': '利益',
  'pages.zy-crm.contract.field.productName': '商品名',
  'pages.zy-crm.contract.field.productType': '商品タイプ',
  'pages.zy-crm.contract.field.productUnit': '単位',
  'pages.zy-crm.contract.field.listPrice': '価格',
  'pages.zy-crm.contract.field.costPrice': '原価',
  'pages.zy-crm.contract.field.salePrice': '販売価格',
  'pages.zy-crm.contract.field.quantity': '数量',
  'pages.zy-crm.contract.field.lineTotal': '小計',
  'pages.zy-crm.contract.field.signContact': '契約連絡先',
  'pages.zy-crm.contract.field.signUser': '契約担当者',
  'pages.zy-crm.contract.field.remark': '備考',
  'pages.zy-crm.contract.field.customerUuid': '顧客',
  'pages.zy-crm.contract.field.opportunityUuid': '商談',
  'pages.zy-crm.contract.field.ownerUserUuid': '担当者',
  'pages.zy-crm.contract.field.processInstanceUuid': 'プロセスインスタンス',
  'pages.zy-crm.contractCodeRule.title': '契約採番ルール',
  'pages.zy-crm.contractCodeRule.cardTitle': '契約採番ルール',
  'pages.zy-crm.contractCodeRule.action.save': '保存',
  'pages.zy-crm.contractCodeRule.action.reset': 'リセット',
  'pages.zy-crm.contractCodeRule.message.saveSuccess':
    '契約採番ルールを保存しました',
  'pages.zy-crm.contractCodeRule.message.loadFailed':
    '契約採番ルールの取得に失敗しました',
  'pages.zy-crm.contractCodeRule.message.saveFailed':
    '契約採番ルールの保存に失敗しました',
  'pages.zy-crm.contractCodeRule.form.required': '必須項目です',
  'pages.zy-crm.contractCodeRule.field.prefix': '採番プレフィックス',
  'pages.zy-crm.contractCodeRule.field.dateFormat': '日付フォーマット',
  'pages.zy-crm.contractCodeRule.field.seqLength': '連番桁数',
  'pages.zy-crm.contractCodeRule.field.resetCycle': 'リセット周期',
  'pages.zy-crm.contractCodeRule.preview.label': '次の番号プレビュー',
  'pages.zy-crm.contractCodeRule.enum.date.none': '日付なし',
  'pages.zy-crm.contractCodeRule.enum.date.yymm': 'YYMM',
  'pages.zy-crm.contractCodeRule.enum.date.yyyymmdd': 'YYYYMMDD',
  'pages.zy-crm.contractCodeRule.enum.cycle.none': 'リセットなし',
  'pages.zy-crm.contractCodeRule.enum.cycle.year': '年ごとにリセット',
  'pages.zy-crm.contractCodeRule.enum.cycle.month': '月ごとにリセット',
  'pages.zy-crm.productCodeRule.title': '商品採番ルール',
  'pages.zy-crm.productCodeRule.cardTitle': '商品採番ルール',
  'pages.zy-crm.productCodeRule.action.save': '保存',
  'pages.zy-crm.productCodeRule.action.reset': 'リセット',
  'pages.zy-crm.productCodeRule.message.saveSuccess':
    '商品採番ルールを保存しました',
  'pages.zy-crm.productCodeRule.message.loadFailed':
    '商品採番ルールの読み込みに失敗しました',
  'pages.zy-crm.productCodeRule.message.saveFailed':
    '商品採番ルールの保存に失敗しました',
  'pages.zy-crm.productCodeRule.form.required': '必須項目です',
  'pages.zy-crm.productCodeRule.field.prefix': '採番プレフィックス',
  'pages.zy-crm.productCodeRule.field.dateFormat': '日付フォーマット',
  'pages.zy-crm.productCodeRule.field.seqLength': '連番桁数',
  'pages.zy-crm.productCodeRule.field.resetCycle': 'リセット周期',
  'pages.zy-crm.productCodeRule.preview.label': '次の番号プレビュー',
  'pages.zy-crm.productCodeRule.enum.date.none': '日付なし',
  'pages.zy-crm.productCodeRule.enum.date.yymm': 'YYMM',
  'pages.zy-crm.productCodeRule.enum.date.yyyymmdd': 'YYYYMMDD',
  'pages.zy-crm.productCodeRule.enum.cycle.none': 'リセットなし',
  'pages.zy-crm.productCodeRule.enum.cycle.year': '年ごとにリセット',
  'pages.zy-crm.productCodeRule.enum.cycle.month': '月ごとにリセット',
  'pages.zy-crm.receipt.title': 'Receipt 一覧',
  'pages.zy-crm.receipt.card.manageTitle': 'Receipt 管理',
  'pages.zy-crm.receipt.action.refresh': '更新',
  'pages.zy-crm.receipt.action.create': '新規作成',
  'pages.zy-crm.receipt.action.detail': '詳細',
  'pages.zy-crm.receipt.action.edit': '編集',
  'pages.zy-crm.receipt.action.delete': '削除',
  'pages.zy-crm.receipt.column.operation': '操作',
  'pages.zy-crm.receipt.modal.createTitle': '新規作成',
  'pages.zy-crm.receipt.modal.editTitle': '編集',
  'pages.zy-crm.receipt.modal.deleteTitle': '削除確認',
  'pages.zy-crm.receipt.modal.deleteContent': '削除後は復元できません。',
  'pages.zy-crm.receipt.form.required': '必須項目です',
  'pages.zy-crm.receipt.form.placeholder.input': '{label}を入力してください',
  'pages.zy-crm.receipt.form.placeholder.select': '{label}を選択してください',
  'pages.zy-crm.receipt.form.placeholder.relation':
    '関連{label}を入力してください',
  'pages.zy-crm.receipt.form.bool.yes': 'はい',
  'pages.zy-crm.receipt.form.bool.no': 'いいえ',
  'pages.zy-crm.receipt.form.group.basic': '基本情報',
  'pages.zy-crm.receipt.form.group.followup': 'フォローアップ情報',
  'pages.zy-crm.receipt.form.group.contact': '連絡先情報',
  'pages.zy-crm.receipt.form.group.business': '業務情報',
  'pages.zy-crm.receipt.form.group.relation': '関連情報',
  'pages.zy-crm.receipt.form.group.detail': '備考',
  'pages.zy-crm.receipt.form.group.other': 'その他情報',
  'pages.zy-crm.receipt.message.createSuccess': '作成に成功しました',
  'pages.zy-crm.receipt.message.updateSuccess': '更新に成功しました',
  'pages.zy-crm.receipt.message.deleteSuccess': '削除に成功しました',
  'pages.zy-crm.receipt.message.noCreateApi': '作成 API が提供されていません',
  'pages.zy-crm.receipt.message.noUpdateApi': '更新 API が提供されていません',
  'pages.zy-crm.receipt.message.noDeleteApi': '削除 API が提供されていません',
  'pages.zy-crm.receipt.message.memberLoadFailed':
    'メンバー一覧の取得に失敗しました',
  'pages.zy-crm.receipt.message.memberLoadBlocked':
    'メンバー取得失敗のため送信できません',
  'pages.zy-crm.receipt.message.detailLoadFailed':
    '詳細の読み込みに失敗しました',
  'pages.zy-crm.receipt.member.unknown': '不明なメンバー',
  'pages.zy-crm.receipt.state.missingUuid': 'uuid パラメータがありません',
  'pages.zy-crm.receipt.state.detailNotFound': '詳細データが見つかりません',
  'pages.zy-crm.receipt.state.relationDataEmpty':
    '関連データは業務 API で補完できます',
  'pages.zy-crm.receipt.card.relation': '関連データ',
  'pages.zy-crm.receipt.search.expand': '展開',
  'pages.zy-crm.receipt.search.collapse': '折りたたみ',
  'pages.zy-crm.receipt.field.id': 'id',
  'pages.zy-crm.receipt.field.code': 'code',
  'pages.zy-crm.receipt.field.receiptScheduleUuid': 'receiptSchedule',
  'pages.zy-crm.receipt.field.customerUuid': 'customer',
  'pages.zy-crm.receipt.field.contractUuid': 'contract',
  'pages.zy-crm.receipt.field.ownerUserUuid': '负责人',
  'pages.zy-crm.receipt.field.auditStatus': 'auditStatus',
  'pages.zy-crm.receipt.field.processInstanceUuid': 'processInstance',
  'pages.zy-crm.receipt.field.receiptDate': 'receiptDate',
  'pages.zy-crm.receipt.field.receiptMethod': 'receiptMethod',
  'pages.zy-crm.receipt.field.price': 'price',
  'pages.zy-crm.receipt.field.remark': 'remark',
  'pages.zy-crm.receipt.placeholder.autoCode': 'システムルールにより自動生成',
  'pages.zy-crm.receipt.option.status.draft': '下書き',
  'pages.zy-crm.receipt.option.status.pending': '承認中',
  'pages.zy-crm.receipt.option.status.approved': '承認済み',
  'pages.zy-crm.receipt.option.status.rejected': '却下',
  'pages.zy-crm.receipt-schedule.title': 'ReceiptSchedule 一覧',
  'pages.zy-crm.receipt-schedule.detailTitle': 'ReceiptSchedule 詳細',
  'pages.zy-crm.receipt-schedule.card.manageTitle': 'ReceiptSchedule 管理',
  'pages.zy-crm.receipt-schedule.action.refresh': '更新',
  'pages.zy-crm.receipt-schedule.action.create': '新規作成',
  'pages.zy-crm.receipt-schedule.action.detail': '詳細',
  'pages.zy-crm.receipt-schedule.action.edit': '編集',
  'pages.zy-crm.receipt-schedule.action.delete': '削除',
  'pages.zy-crm.receipt-schedule.column.operation': '操作',
  'pages.zy-crm.receipt-schedule.modal.createTitle': '新規作成',
  'pages.zy-crm.receipt-schedule.modal.editTitle': '編集',
  'pages.zy-crm.receipt-schedule.modal.deleteTitle': '削除確認',
  'pages.zy-crm.receipt-schedule.modal.deleteContent':
    '削除後は復元できません。',
  'pages.zy-crm.receipt-schedule.form.required': '必須項目です',
  'pages.zy-crm.receipt-schedule.form.placeholder.input':
    '{label}を入力してください',
  'pages.zy-crm.receipt-schedule.form.placeholder.select':
    '{label}を選択してください',
  'pages.zy-crm.receipt-schedule.form.placeholder.relation':
    '関連{label}を入力してください',
  'pages.zy-crm.receipt-schedule.form.bool.yes': 'はい',
  'pages.zy-crm.receipt-schedule.form.bool.no': 'いいえ',
  'pages.zy-crm.receipt-schedule.form.group.basic': '基本情報',
  'pages.zy-crm.receipt-schedule.form.group.followup': 'フォローアップ情報',
  'pages.zy-crm.receipt-schedule.form.group.contact': '連絡先情報',
  'pages.zy-crm.receipt-schedule.form.group.business': '業務情報',
  'pages.zy-crm.receipt-schedule.form.group.relation': '関連情報',
  'pages.zy-crm.receipt-schedule.form.group.detail': '備考',
  'pages.zy-crm.receipt-schedule.form.group.other': 'その他情報',
  'pages.zy-crm.receipt-schedule.message.createSuccess': '作成に成功しました',
  'pages.zy-crm.receipt-schedule.message.updateSuccess': '更新に成功しました',
  'pages.zy-crm.receipt-schedule.message.deleteSuccess': '削除に成功しました',
  'pages.zy-crm.receipt-schedule.message.noCreateApi':
    '作成 API が提供されていません',
  'pages.zy-crm.receipt-schedule.message.noUpdateApi':
    '更新 API が提供されていません',
  'pages.zy-crm.receipt-schedule.message.noDeleteApi':
    '削除 API が提供されていません',
  'pages.zy-crm.receipt-schedule.message.memberLoadFailed':
    'メンバー一覧の取得に失敗しました',
  'pages.zy-crm.receipt-schedule.message.memberLoadBlocked':
    'メンバー取得失敗のため送信できません',
  'pages.zy-crm.receipt-schedule.message.detailLoadFailed':
    '詳細の読み込みに失敗しました',
  'pages.zy-crm.receipt-schedule.member.unknown': '不明なメンバー',
  'pages.zy-crm.receipt-schedule.state.missingUuid':
    'uuid パラメータがありません',
  'pages.zy-crm.receipt-schedule.state.detailNotFound':
    '詳細データが見つかりません',
  'pages.zy-crm.receipt-schedule.state.relationDataEmpty':
    '関連データは業務 API で補完できます',
  'pages.zy-crm.receipt-schedule.card.relation': '関連データ',
  'pages.zy-crm.receipt-schedule.search.expand': '展開',
  'pages.zy-crm.receipt-schedule.search.collapse': '折りたたみ',
  'pages.zy-crm.receipt-schedule.field.id': 'id',
  'pages.zy-crm.receipt-schedule.field.period': 'period',
  'pages.zy-crm.receipt-schedule.field.customerUuid': 'customer',
  'pages.zy-crm.receipt-schedule.field.contractUuid': 'contract',
  'pages.zy-crm.receipt-schedule.field.ownerUserUuid': '负责人',
  'pages.zy-crm.receipt-schedule.field.receiptUuid': 'receipt',
  'pages.zy-crm.receipt-schedule.field.receiptDate': 'receiptDate',
  'pages.zy-crm.receipt-schedule.field.receiptMethod': 'receiptMethod',
  'pages.zy-crm.receipt-schedule.field.price': 'price',
  'pages.zy-crm.receipt-schedule.field.receivedAmount': '入金済金額',
  'pages.zy-crm.receipt-schedule.field.unpaidAmount': '未入金金額',
  'pages.zy-crm.receipt-schedule.field.remindDays': 'remindDays',
  'pages.zy-crm.receipt-schedule.field.remindTime': 'remindTime',
  'pages.zy-crm.receipt-schedule.field.remark': 'remark',
  'pages.zy-crm.calendar.title': 'カレンダー',
  'pages.zy-crm.calendar.action.today': '今日',
  'pages.zy-crm.calendar.action.prev': '前へ',
  'pages.zy-crm.calendar.action.next': '次へ',
  'pages.zy-crm.calendar.action.create': '作成',
  'pages.zy-crm.calendar.action.refresh': '更新',
  'pages.zy-crm.calendar.action.save': '保存',
  'pages.zy-crm.calendar.action.delete': '削除',
  'pages.zy-crm.calendar.action.openSource': '元データを開く',
  'pages.zy-crm.calendar.view.day': '日',
  'pages.zy-crm.calendar.view.week': '週',
  'pages.zy-crm.calendar.view.month': '月',
  'pages.zy-crm.calendar.view.list': '一覧',
  'pages.zy-crm.calendar.sidebar.mySchedule': '自分の予定',
  'pages.zy-crm.calendar.sidebar.systemType': '活動タイプ',
  'pages.zy-crm.calendar.sidebar.otherCalendar': '他のカレンダー',
  'pages.zy-crm.calendar.filter.my_schedule': '自分の予定',
  'pages.zy-crm.calendar.filter.assigned_task': '割り当てタスク',
  'pages.zy-crm.calendar.filter.phone_communication': '電話連絡',
  'pages.zy-crm.calendar.filter.send_email': 'メール送信',
  'pages.zy-crm.calendar.filter.online_meeting': 'オンライン会議',
  'pages.zy-crm.calendar.filter.visit': '訪問',
  'pages.zy-crm.calendar.filter.send_sms': 'SMS送信',
  'pages.zy-crm.calendar.filter.lead_follow_up': 'リードフォロー',
  'pages.zy-crm.calendar.filter.customer_follow_up': '顧客フォロー',
  'pages.zy-crm.calendar.filter.contact_follow_up': '連絡先フォロー',
  'pages.zy-crm.calendar.filter.opportunity_follow_up': '商談フォロー',
  'pages.zy-crm.calendar.filter.opportunity_deal': '成約予定',
  'pages.zy-crm.calendar.filter.contract_expire': '契約期限',
  'pages.zy-crm.calendar.filter.receipt_schedule': '入金予定',
  'pages.zy-crm.calendar.drawer.createTitle': '予定を新規作成',
  'pages.zy-crm.calendar.drawer.editTitle': '予定を編集',
  'pages.zy-crm.calendar.drawer.detailTitle': '予定詳細',
  'pages.zy-crm.calendar.form.title': 'タイトル',
  'pages.zy-crm.calendar.form.eventType': 'タイプ',
  'pages.zy-crm.calendar.form.startTime': '開始時間',
  'pages.zy-crm.calendar.form.endTime': '終了時間',
  'pages.zy-crm.calendar.form.allDay': '終日',
  'pages.zy-crm.calendar.form.location': '場所',
  'pages.zy-crm.calendar.form.description': '説明',
  'pages.zy-crm.calendar.form.color': '色',
  'pages.zy-crm.calendar.form.placeholder.title': 'タイトルを入力してください',
  'pages.zy-crm.calendar.form.placeholder.location': '場所を入力してください',
  'pages.zy-crm.calendar.message.loadFailed':
    'カレンダーデータの読み込みに失敗しました',
  'pages.zy-crm.calendar.message.createSuccess': '予定を作成しました',
  'pages.zy-crm.calendar.message.updateSuccess': '予定を更新しました',
  'pages.zy-crm.calendar.message.deleteSuccess': '予定を削除しました',
  'pages.zy-crm.calendar.message.saveFailed':
    '保存に失敗しました。しばらくして再試行してください。',
  'pages.zy-crm.calendar.message.deleteFailed':
    '削除に失敗しました。しばらくして再試行してください。',
  'pages.zy-crm.calendar.empty.noEventType':
    '少なくとも 1 つのカレンダータイプを選択してください',
  'pages.zy-crm.calendar.readonly.system': 'システムイベントは編集できません',
  'pages.zy-crm.quote.title': '見積一覧',
  'pages.zy-crm.quote.detailTitle': '見積詳細',
  'pages.zy-crm.quote.action.refresh': '更新',
  'pages.zy-crm.quote.action.create': '新規作成',
  'pages.zy-crm.quote.action.codeRule': '採番ルール',
  'pages.zy-crm.quote.action.detail': '詳細',
  'pages.zy-crm.quote.action.edit': '編集',
  'pages.zy-crm.quote.action.delete': '削除',
  'pages.zy-crm.quote.action.restore': '復元',
  'pages.zy-crm.quote.action.reuse': '再利用',
  'pages.zy-crm.quote.action.history': '履歴見積を表示/再利用',
  'pages.zy-crm.quote.action.search': '検索',
  'pages.zy-crm.quote.action.addProduct': '製品追加',
  'pages.zy-crm.quote.action.addRow': '行を追加',
  'pages.zy-crm.quote.action.saveCodeRule': 'ルール保存',
  'pages.zy-crm.quote.column.operation': '操作',
  'pages.zy-crm.quote.modal.createTitle': '見積を新規作成',
  'pages.zy-crm.quote.modal.editTitle': '見積を編集',
  'pages.zy-crm.quote.modal.deleteTitle': '削除確認',
  'pages.zy-crm.quote.modal.deleteContent': '削除後は復元できません。',
  'pages.zy-crm.quote.modal.restoreTitle': 'この見積を復元しますか？',
  'pages.zy-crm.quote.modal.restoreContent': '今すぐ削除を取り消せます。',
  'pages.zy-crm.quote.modal.historyTitle': '履歴見積',
  'pages.zy-crm.quote.modal.diffTitle': '金額差異の確認',
  'pages.zy-crm.quote.modal.diffContent':
    '手入力合計と明細計算値の差異は {diff} です。送信しますか？',
  'pages.zy-crm.quote.modal.crossCustomerTitle': '顧客跨ぎ再利用の確認',
  'pages.zy-crm.quote.modal.crossCustomerContent':
    '現在の顧客と履歴見積の顧客が異なります。顧客情報を上書きして続行しますか？',
  'pages.zy-crm.quote.modal.codeRuleTitle': '見積採番ルール',
  'pages.zy-crm.quote.form.required': '必須項目です',
  'pages.zy-crm.quote.form.autoCodeHint': '採番ルールにより自動生成',
  'pages.zy-crm.quote.form.placeholder.input': '{label}を入力してください',
  'pages.zy-crm.quote.form.placeholder.select': '{label}を選択してください',
  'pages.zy-crm.quote.form.group.basic': '基本情報',
  'pages.zy-crm.quote.form.group.relation': '関連情報',
  'pages.zy-crm.quote.form.group.date': '日付情報',
  'pages.zy-crm.quote.form.group.product': '製品情報',
  'pages.zy-crm.quote.form.group.amount': '金額集計',
  'pages.zy-crm.quote.form.group.remark': '備考',
  'pages.zy-crm.quote.message.createSuccess': '作成に成功しました',
  'pages.zy-crm.quote.message.updateSuccess': '更新に成功しました',
  'pages.zy-crm.quote.message.deleteSuccess': '削除に成功しました',
  'pages.zy-crm.quote.message.restoreSuccess': '復元に成功しました',
  'pages.zy-crm.quote.message.reuseSuccess': '履歴見積の再利用に成功しました',
  'pages.zy-crm.quote.message.memberLoadFailed':
    'メンバー一覧の取得に失敗しました',
  'pages.zy-crm.quote.message.memberLoadBlocked':
    'メンバー一覧取得失敗のため送信できません',
  'pages.zy-crm.quote.message.customerLoadFailed':
    '顧客一覧の取得に失敗しました',
  'pages.zy-crm.quote.message.contactLoadFailed':
    '連絡先一覧の取得に失敗しました',
  'pages.zy-crm.quote.message.opportunityLoadFailed':
    '商談一覧の取得に失敗しました',
  'pages.zy-crm.quote.message.productLoadFailed':
    '製品一覧の取得に失敗しました',
  'pages.zy-crm.quote.message.historyLoadFailed':
    '履歴見積の取得に失敗しました',
  'pages.zy-crm.quote.message.productEmpty':
    '製品明細を最低 1 件追加してください',
  'pages.zy-crm.quote.message.detailLoadFailed': '詳細の読み込みに失敗しました',
  'pages.zy-crm.quote.message.codeRuleLoadFailed':
    '見積採番ルールの取得に失敗しました',
  'pages.zy-crm.quote.message.codeRuleUpdateSuccess':
    '採番ルールの更新に成功しました',
  'pages.zy-crm.quote.search.expand': '展開',
  'pages.zy-crm.quote.search.collapse': '折りたたみ',
  'pages.zy-crm.quote.state.diffNeedsConfirm':
    '金額差異が未確認のため、送信を中止しました',
  'pages.zy-crm.quote.state.missingUuid': 'uuid パラメータがありません',
  'pages.zy-crm.quote.state.detailNotFound': '詳細データが見つかりません',
  'pages.zy-crm.quote.history.range.lastMonth': '直近1か月',
  'pages.zy-crm.quote.history.range.halfYear': '直近半年',
  'pages.zy-crm.quote.history.range.thisYear': '今年',
  'pages.zy-crm.quote.table.emptyProducts': '製品明細はありません',
  'pages.zy-crm.quote.table.emptyHistory': '履歴見積はありません',
  'pages.zy-crm.quote.stats.selectedProducts': '選択製品: {count}',
  'pages.zy-crm.quote.stats.quoteAmount': '合計金額: {amount}',
  'pages.zy-crm.quote.option.dateFormat.none': '日付なし',
  'pages.zy-crm.quote.option.dateFormat.yymm': '年/月(YYMM)',
  'pages.zy-crm.quote.option.dateFormat.yyyymmdd': '年/月/日(YYYYMMDD)',
  'pages.zy-crm.quote.option.resetCycle.none': 'リセットなし',
  'pages.zy-crm.quote.option.resetCycle.year': '年次リセット',
  'pages.zy-crm.quote.option.resetCycle.month': '月次リセット',
  'pages.zy-crm.quote.status.approved': '承認済み',
  'pages.zy-crm.quote.status.submitted': '審査中',
  'pages.zy-crm.quote.status.rejected': '却下',
  'pages.zy-crm.quote.status.draft': '下書き',
  'pages.zy-crm.quote.field.code': '見積番号',
  'pages.zy-crm.quote.field.name': '見積名',
  'pages.zy-crm.quote.field.customerUuid': '顧客',
  'pages.zy-crm.quote.field.contactUuid': '顧客担当者',
  'pages.zy-crm.quote.field.opportunityUuid': '商談',
  'pages.zy-crm.quote.field.quoteDate': '見積日',
  'pages.zy-crm.quote.field.expectedDealDate': '成約予定日',
  'pages.zy-crm.quote.field.ownerUserUuid': '担当者',
  'pages.zy-crm.quote.field.ownerMobile': '担当者携帯',
  'pages.zy-crm.quote.field.auditStatus': '審査状態',
  'pages.zy-crm.quote.field.discountPercent': '値引率(%)',
  'pages.zy-crm.quote.field.totalProductPrice': '製品原価合計',
  'pages.zy-crm.quote.field.totalPrice': '見積金額',
  'pages.zy-crm.quote.field.profitAmount': '利益',
  'pages.zy-crm.quote.field.remark': '備考',
  'pages.zy-crm.quote.field.sourceQuoteUuid': '元見積',
  'pages.zy-crm.quote.field.products': '製品',
  'pages.zy-crm.quote.field.productName': '製品名',
  'pages.zy-crm.quote.field.productType': '製品タイプ',
  'pages.zy-crm.quote.field.productUnit': '単位',
  'pages.zy-crm.quote.field.listPrice': '価格',
  'pages.zy-crm.quote.field.costPrice': '原価',
  'pages.zy-crm.quote.field.salePrice': '売価',
  'pages.zy-crm.quote.field.quantity': '数量',
  'pages.zy-crm.quote.field.lineTotal': '小計',
  'pages.zy-crm.quote.field.historyRange': '期間',
  'pages.zy-crm.quote.field.historyKeyword': 'キーワード',
  'pages.zy-crm.quote.field.dateFormat': '日付形式',
  'pages.zy-crm.quote.field.resetCycle': 'リセット周期',
  'pages.zy-crm.quote.field.seqLength': '連番桁数',
  'pages.zy-crm.quote.field.prefix': 'プレフィックス',
  'pages.zy-crm.followUps.title': 'フォローアップ記録一覧',
  'pages.zy-crm.invoice.title': '請求書一覧',
  'pages.zy-crm.invoice.detailTitle': '請求書詳細',
  'pages.zy-crm.invoice.action.refresh': '更新',
  'pages.zy-crm.invoice.action.create': '請求書作成',
  'pages.zy-crm.invoice.action.detail': '詳細',
  'pages.zy-crm.invoice.action.edit': '編集',
  'pages.zy-crm.invoice.action.delete': '削除',
  'pages.zy-crm.invoice.action.submit': '申請',
  'pages.zy-crm.invoice.action.addItem': '明細追加',
  'pages.zy-crm.invoice.action.back': '一覧へ戻る',
  'pages.zy-crm.invoice.action.save': '保存',
  'pages.zy-crm.invoice.action.cancel': 'キャンセル',
  'pages.zy-crm.invoice.action.manageProfile': '請求情報を管理',
  'pages.zy-crm.invoice.action.selectProfile': '請求情報を選択',
  'pages.zy-crm.invoice.modal.createTitle': '請求書作成',
  'pages.zy-crm.invoice.modal.editTitle': '請求書編集',
  'pages.zy-crm.invoice.modal.deleteTitle': '削除確認',
  'pages.zy-crm.invoice.modal.deleteContent': '削除後は復元できません。',
  'pages.zy-crm.invoice.column.operation': '操作',
  'pages.zy-crm.invoice.search.expand': '展開',
  'pages.zy-crm.invoice.search.collapse': '折りたたみ',
  'pages.zy-crm.invoice.form.group.basic': '基本情報',
  'pages.zy-crm.invoice.form.group.invoice': '請求情報',
  'pages.zy-crm.invoice.form.placeholder.input': '{label}を入力してください',
  'pages.zy-crm.invoice.form.placeholder.select': '{label}を選択してください',
  'pages.zy-crm.invoice.form.required': '必須項目です',
  'pages.zy-crm.invoice.message.createSuccess': '作成に成功しました',
  'pages.zy-crm.invoice.message.updateSuccess': '更新に成功しました',
  'pages.zy-crm.invoice.message.deleteSuccess': '削除に成功しました',
  'pages.zy-crm.invoice.message.submitSuccess': '申請に成功しました',
  'pages.zy-crm.invoice.message.detailLoadFailed': '詳細取得に失敗しました',
  'pages.zy-crm.invoice.message.profileRequired': '請求情報を選択してください',
  'pages.zy-crm.invoice.message.manualSnapshotRequired':
    '宛名種別、請求宛名、税番号を入力してください',
  'pages.zy-crm.invoice.message.contractRequired': '先に契約を選択してください',
  'pages.zy-crm.invoice.message.itemsRequired':
    '少なくとも1件の明細を追加してください',
  'pages.zy-crm.invoice.member.unknown': '不明なメンバー',
  'pages.zy-crm.invoice.state.missingUuid': 'uuid パラメータがありません',
  'pages.zy-crm.invoice.state.detailNotFound': '詳細データが見つかりません',
  'pages.zy-crm.invoice.state.emptyItems': 'データなし',
  'pages.zy-crm.invoice.state.relationDataEmpty':
    '関連データは業務 API と連携して補完できます',
  'pages.zy-crm.invoice.placeholder.autoCode': '採番ルールにより自動生成',
  'pages.zy-crm.invoice.field.code': '申請番号',
  'pages.zy-crm.invoice.field.customerUuid': '顧客',
  'pages.zy-crm.invoice.field.customerName': '顧客名',
  'pages.zy-crm.invoice.field.contractUuid': '契約',
  'pages.zy-crm.invoice.field.contractName': '契約名',
  'pages.zy-crm.invoice.field.ownerUserUuid': '担当者',
  'pages.zy-crm.invoice.field.invoiceDate': '請求日',
  'pages.zy-crm.invoice.field.invoiceType': '請求種別',
  'pages.zy-crm.invoice.field.auditStatus': '状態',
  'pages.zy-crm.invoice.field.processInstanceUuid': 'プロセスインスタンス',
  'pages.zy-crm.invoice.field.invoiceProfileName': '宛名プロファイル',
  'pages.zy-crm.invoice.field.totalAmount': '請求金額',
  'pages.zy-crm.invoice.field.remark': '備考',
  'pages.zy-crm.invoice.field.invoiceProfileUuid': '請求情報',
  'pages.zy-crm.invoice.field.titleType': '宛名種別',
  'pages.zy-crm.invoice.field.titleSnapshot': '請求宛名',
  'pages.zy-crm.invoice.field.taxNoSnapshot': '税番号',
  'pages.zy-crm.invoice.field.bankNameSnapshot': '銀行名',
  'pages.zy-crm.invoice.field.bankAccountSnapshot': '口座番号',
  'pages.zy-crm.invoice.field.addressSnapshot': '住所',
  'pages.zy-crm.invoice.field.phoneSnapshot': '電話番号',
  'pages.zy-crm.invoice.field.saveAsProfile': 'よく使う請求情報として保存',
  'pages.zy-crm.invoice.field.mailContact': '連絡先',
  'pages.zy-crm.invoice.field.mailPhone': '連絡方法',
  'pages.zy-crm.invoice.field.mailAddressRegion': '郵送先住所',
  'pages.zy-crm.invoice.field.mailAddressDetail': '詳細住所',
  'pages.zy-crm.invoice.field.items': '請求明細',
  'pages.zy-crm.invoice.section.items': '入金明細',
  'pages.zy-crm.invoice.field.receiptCode': '入金番号',
  'pages.zy-crm.invoice.field.receiptScheduleCode': '入金予定番号',
  'pages.zy-crm.invoice.field.contractCode': '契約番号',
  'pages.zy-crm.invoice.field.contractAmount': '契約金額',
  'pages.zy-crm.invoice.field.uninvoicedAmount': '未請求金額',
  'pages.zy-crm.invoice.field.invoiceAmount': '今回請求金額',
  'pages.zy-crm.invoice.field.receiptDate': '入金日',
  'pages.zy-crm.invoice.field.receiptMethod': '入金方法',
  'pages.zy-crm.invoice.field.createdAt': '作成日時',
  'pages.zy-crm.invoice.option.type.normal': '普通請求書',
  'pages.zy-crm.invoice.option.type.special': '専用請求書',
  'pages.zy-crm.invoice.option.title.company': '法人',
  'pages.zy-crm.invoice.option.title.personal': '個人',
  'pages.zy-crm.invoice.option.status.draft': '下書き',
  'pages.zy-crm.invoice.option.status.pending': '承認待ち',
  'pages.zy-crm.invoice.option.status.approved': '承認済み',
  'pages.zy-crm.invoice.option.status.rejected': '差戻し',
  'pages.zy-crm.invoice.section.mailing': '郵送情報',
  'pages.zy-crm.invoice.card.invoiceInfo': '請求情報',
  'pages.zy-crm.invoice.card.mailing': '郵送情報',
  'pages.zy-crm.invoice-profile.title': '請求情報管理',
  'pages.zy-crm.invoice-profile.action.refresh': '更新',
  'pages.zy-crm.invoice-profile.action.create': '請求情報作成',
  'pages.zy-crm.invoice-profile.action.edit': '編集',
  'pages.zy-crm.invoice-profile.action.delete': '削除',
  'pages.zy-crm.invoice-profile.column.operation': '操作',
  'pages.zy-crm.invoice-profile.modal.createTitle': '請求情報作成',
  'pages.zy-crm.invoice-profile.modal.editTitle': '請求情報編集',
  'pages.zy-crm.invoice-profile.modal.deleteTitle': '削除確認',
  'pages.zy-crm.invoice-profile.modal.deleteContent':
    '削除後は復元できません。',
  'pages.zy-crm.invoice-profile.form.required': '必須項目です',
  'pages.zy-crm.invoice-profile.message.createSuccess': '作成に成功しました',
  'pages.zy-crm.invoice-profile.message.updateSuccess': '更新に成功しました',
  'pages.zy-crm.invoice-profile.message.deleteSuccess': '削除に成功しました',
  'pages.zy-crm.invoice-profile.message.detailLoadFailed':
    '詳細取得に失敗しました',
  'pages.zy-crm.invoice-profile.field.name': 'プロファイル名',
  'pages.zy-crm.invoice-profile.field.type': '宛名種別',
  'pages.zy-crm.invoice-profile.field.title': '請求宛名',
  'pages.zy-crm.invoice-profile.field.taxNo': '税番号',
  'pages.zy-crm.invoice-profile.field.bankName': '銀行名',
  'pages.zy-crm.invoice-profile.field.bankAccount': '口座番号',
  'pages.zy-crm.invoice-profile.field.address': '住所',
  'pages.zy-crm.invoice-profile.field.phone': '電話番号',
  'pages.zy-crm.invoice-profile.field.isDefault': '既定',
  'pages.zy-crm.invoice-profile.field.remark': '備考',
  'pages.zy-crm.invoice-profile.field.createdAt': '作成日時',
  'pages.zy-crm.invoice-profile.option.boolean.yes': 'はい',
  'pages.zy-crm.invoice-profile.option.boolean.no': 'いいえ',
  'pages.zy-crm.contactOpportunity.field.status': '状態',
};
